import Cookies from 'js-cookie'
import DataSource from '@/data/datasource'
import configAdmin from '@/config/configAdmin'

export const getStaffPortalStatus = () => {
  if (
    window.location.host.toUpperCase().includes(process.env.VUE_APP_ROOT_API3.toUpperCase()) ||
    window.location.host.toUpperCase().includes(process.env.VUE_APP_ROOT_API7.toUpperCase())
  ) {
    return true
  }
}

export const getParentSiteBase = () => {
  if (process.env.VUE_APP_ROOT_API.toUpperCase().includes('KWS-UAT')) {
    return 'https://parent-uat.etonhouse.com'
  } else {
    return 'https://parent.etonhouse.com'
  }
}

export const getBase = () => {
  if (process.env.VUE_APP_ROOT_API.toUpperCase().includes('KWS-UAT')) {
    return 'https://api-uat.etonhouse.com'
  } else {
    return 'https://api.etonhouse.com'
  }
}

export const getActivityImageBase = (src, isVideo) => {
  let host = getBase()

  if (isVideo) {
    return host + '/fs/PORTFOLIOS/' + src.PostSchoolID + '/' + src.PostItemID + src.PostItemFileExt
  } else {
    return host + '/files/images?e=POST&w=600&f=' + src.PostItemID + src.PostItemFileExt + '&args=' + src.PostSchoolID
  }
}

export const getRole = () => {
  return Cookies.get('userTypeSession')
}

export const getUserID = () => {
  return Cookies.get('userIDSession')
}

export const getUsRidSession = () => {
  return Cookies.get('usRidSession')
}

export const getUserNameSession = () => {
  return Cookies.get('userNameSession')
}

export const isInternational = school => {
  let internationalList = [
    'Orchard',
    'Broadrick',
    'Thomson',
    'Sentosa',
    'Claymore',
    'M718',
    'Thomson Primary',
    'Sentosa Primary',
    'Middleton Tampines',
    'Middleton Upp Bukit Timah',
    'Middleton West Coast',
  ]
  return internationalList?.find(d => d === school)
}

export const getUserGroup = async () => {
  let usrID = getUsRidSession()
  const resp = await DataSource.shared.getUserGroupByUSRID(usrID)

  if (resp) {
    if (resp.code === '99') {
      console.log('99')
    } else if (resp.code === '88') {
      console.log('88')
    } else {
      return resp.Table
    }
  }
}

export const getCurrentSchool = () => {
  return Cookies.get('userSchoolNameSession')
}

export const getSchoolSession = () => {
  if (window.location.host.toUpperCase().includes(process.env.VUE_APP_ROOT_API4.toUpperCase())) {
    let schIDs = JSON.parse(Cookies.get('schoolSession'))
    return schIDs?.Table
  } else {
    return Cookies.get('schoolSession')
  }
}

export const getActivityUploadPreviewBase = () => {
  if (process.env.VUE_APP_ROOT_API.toUpperCase().includes('KWS-UAT')) {
    return 'https://kws-uat.etonhouse.com/External/TempUploads/'
  } else {
    return 'https://kws.etonhouse.com/External/TempUploads/'
  }
}

export const checkIsMiddleton = () => {
  return getCurrentSchool()?.includes('Middleton')
}

export const checkIsPreschool = schoolID => {
  const exist = configAdmin.preSchool?.find(d => d === schoolID)
  return !!exist
}

export const isJapanSchool = school => {
  return ['KLH(PS)', 'Akasaka', 'Toranomon', 'JELC', 'KLH(AS)']?.includes(school)
}

export const inDevelopment = () => {
  return process.env.NODE_ENV === 'development'
}

// SCH201400000480 = M223
// SCH201400000501 = Vanda
const MEDICINE_MENU_ALLOWED_SCHOOL_IDS = ['SCH201400000480', 'SCH201400000501']

export const showMedicineMenu = () => {
  const schoolId = Cookies.get('schoolSession')
  return MEDICINE_MENU_ALLOWED_SCHOOL_IDS.includes(schoolId)
}
